module.exports = __webpack_public_path__ + "img/banner_blue.c439490e.jpg";